export default __webpack_public_path__ + "static/media/heart_container.db75eb15.png";